// NOTE: This is incomplete
interface Employee {
  id: string;
  company_id: string;
  first_name: string;
  last_name: string;
  email: string;
  settings: {
    country: string;
  };
}

const createUserFromEmployee = (employee: Employee) => ({
  key: employee.id,
  anonymous: false,
  firstName: employee.first_name,
  lastName: employee.last_name,
  country: employee.settings.country,
  custom: {
    companyId: employee.company_id,
  },
});

export { createUserFromEmployee };
